export default __webpack_public_path__ + "static/media/nivia.398dfdb6.jpg";